import React from 'react';
import PropTypes from 'prop-types';

import ContentList from '../Global/Lists/ContentList';
import Icon from '../Global/Icons/Icon';
import SharePermissionDropdown from "./SharePermissionDropdown";
import VerticalTextLockup from '../Global/Typography/VerticalTextLockup';

const ShareFolderList = ({ folder, availableAccessors, shareAccessorClick, shareAccessorId, permissionSelect }) => {
  const folderAccessorIds = folder.accessors ? folder.accessors.map(accessor => accessor.id) : [];

  const defaultOption = { value: `none`, label: `Hidden` };
  const removeOption = { value: `remove`, label: `Hide` };
  const viewerOption = { value: `viewer`, label: `Share` };

  const accessorPermissionsMap = availableAccessors.reduce((map, accessor) => {
    if (folderAccessorIds.includes(accessor.id)) {
      map[accessor.id] = {
        default: { value: `viewer`, label: `Shared`},
        options: [removeOption],
      };
    } else {
      map[accessor.id] = {
        default: defaultOption,
        options: [viewerOption],
      };
    }
    return map;
  }, {});

  return (
    <ContentList>
      {availableAccessors.map((accessor) => {
        return (
          <li key={accessor.id}>
            <div className="content-list-new__list-item">
              <Icon name="outline-team" size="m" fill="green" style={{ marginRight: `15px` }} />

              <VerticalTextLockup
                title={<h3 className="like-p">{accessor.name}</h3>}
              />

              <SharePermissionDropdown
                accessor={accessor}
                active={shareAccessorId === accessor.id}
                permissionOptions={accessorPermissionsMap[accessor.id]}
                onAccessorClick={shareAccessorClick}
                onPermissionClick={permissionSelect}
              />

            </div>
          </li>
        );
      })
      }
    </ContentList>
  );
};

ShareFolderList.propTypes = {
  folder: PropTypes.object,
  availableAccessors: PropTypes.array.isRequired,
  shareAccessorClick: PropTypes.func.isRequired,
  shareAccessorId: PropTypes.number,
  permissionSelect: PropTypes.func.isRequired,
};

export default ShareFolderList;



// WEBPACK FOOTER //
// ./library/app/components/Folders/ShareFolderList.js